import { useState, useMemo, useCallback } from 'react';
import { JournalByDate, Order } from '../Statistics.types';

export const useJournalSorting = (journals: any[] = []) => {
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<keyof JournalByDate>('count');

  const sortedJournals = useMemo(() => {
    const filteredJournals = journals.filter((journal: any) => 
      journal.name && journal.name.trim() !== ''
    );
    return [...filteredJournals].sort((a, b) => {
      const multiplier = order === 'asc' ? 1 : -1;
      
      // Get the actual values to compare
      let aValue = a[orderBy];
      let bValue = b[orderBy];
      
      // Handle agreement column - use agreement_name if agreement is missing
      if (orderBy === 'agreement') {
        aValue = a.agreement || a.agreement_name || '';
        bValue = b.agreement || b.agreement_name || '';
      }
      
      // Case-insensitive comparison and trim spaces for string fields
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        aValue = aValue.trim().toLowerCase();
        bValue = bValue.trim().toLowerCase();
      }
      
      // Handle null/undefined values
      if (aValue == null) aValue = '';
      if (bValue == null) bValue = '';
      
      // Compare values
      if (aValue > bValue) return multiplier * 1;
      if (aValue < bValue) return multiplier * -1;
      return 0;
    });
  }, [journals, order, orderBy]);

  const handleSort = useCallback((property: keyof JournalByDate) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  }, [order, orderBy]);

  return {
    sortedJournals,
    order,
    orderBy,
    handleSort
  };
};